import { inject, Service } from '@angular/core';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';

import { BaasAppState } from '@lvflanders/bar';
import { BarInitializedHook } from '@lvflanders/bar-ng';

@Service({ autoProvided: false })
/** Lifecycle hook for BAR ag grid module. */
export class BarAgGridInitializedHook implements BarInitializedHook {
    readonly #state = inject(BaasAppState, { optional: true });

    _framework = true;

    run(): void {
        // Register all features
        ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

        if (this.#state != null) {
            // set ag-Grid license key after BAR is initialized
            try {
                LicenseManager.setLicenseKey(this.#state.config.agGridLicense);
            } catch {
                console.warn('License manager not found, are you sure ag-Grid has been added to the project?');
            }
        }
    }
}
